import { render, staticRenderFns } from "./template.vue?vue&type=template&id=387ae762&scoped=true&"
import script from "@/Components/Modules/CheckList/AddonForm/component.ts?vue&type=script&lang=ts&"
export * from "@/Components/Modules/CheckList/AddonForm/component.ts?vue&type=script&lang=ts&"
import style0 from "@/Components/Modules/CheckList/AddonForm/style.scss?vue&type=style&index=0&id=387ae762&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387ae762",
  null
  
)

export default component.exports